import { Configuration } from "@freightsimple/generated-dashboard-openapi-client/runtime";
import { PostalCodesApi } from "@freightsimple/generated-dashboard-openapi-client/apis/PostalCodesApi";
import { getConfig } from "@/Apis/getConfig";

export function usePostalCodesApi(): PostalCodesApi {
  return new PostalCodesApi(new Configuration({ ...getConfig() }));
}
